import countriesData from "./country-data";

var contactFormInit;

(function ($) {

	const selectors = {
		wrap: '[data-contact-form]',
		codeDropdown: '.js-code-dropdown',
	}

	contactFormInit = function () {
		$(selectors.wrap).each((i, el) => {
			new ContactForm(el);
		});
	}

	class ContactForm {
		constructor(element) {
			this.$wrap = $(element);

			this.init();
			this.bind();

			this.initChoices();

		}
		init() {
			this.$codeDropdown = $(selectors.codeDropdown, this.$wrap);
			this.$codeDropdown.html('');
		}

		bind() {
		}
		initChoices() {
			if (!this.$codeDropdown.length) return;

			// Get current language from HTML lang attribute
			const htmlLang = document.documentElement.lang || 'en-GB';
			let currentCountryCode = 'GB'; // Default to GB

			// Split the lang attribute and get country code
			const langParts = htmlLang.split('-');
			if (langParts.length > 1 && langParts[1]) {
				currentCountryCode = langParts[1].toUpperCase();
			} else {
				// Try underscore format (e.g., en_GB)
				const underscoreParts = htmlLang.split('_');
				if (underscoreParts.length > 1 && underscoreParts[1]) {
					currentCountryCode = underscoreParts[1].toUpperCase();
				}
			}

			// Create choices array from countriesData
			const choicesArray = countriesData.map(country => ({
				value: `+${country.countryCallingCode}`,
				label: country.countryCode,
				customProperties: {
					code: country.countryCode.toLowerCase(),
					fullName: country.countryNameEn
				}
			}));

			// Find the country that matches the current language
			let currentCountryIndex = -1;
			for (let i = 0; i < choicesArray.length; i++) {
				if (choicesArray[i].label === currentCountryCode ||
					choicesArray[i].customProperties.code.toUpperCase() === currentCountryCode) {
					currentCountryIndex = i;
					break;
				}
			}

			// If found, move it to the beginning of the array
			if (currentCountryIndex > -1) {
				const currentCountry = choicesArray[currentCountryIndex];
				choicesArray.splice(currentCountryIndex, 1);
				choicesArray.unshift(currentCountry);
			}

			this.choices = new Choices(this.$codeDropdown[0], {
				choices: choicesArray,
				searchEnabled: true,
				itemSelectText: '',
				searchFields: ['label', 'value', 'customProperties.fullName'],
				callbackOnCreateTemplates: function (strToEl, escapeForTemplate, getClassNames) {
					return {
						item: function (args, data) {
							// Get the original template
							const original = Choices.defaults.templates.item.call(this, args, data);

							// Create new element with flag
							const element = strToEl(`
            <div>
              <span class="fi fi-${data.customProperties.code}"></span>
              ${data.value}
            </div>
          `);

							// Replace the original content
							original.innerHTML = '';
							original.appendChild(element);

							return original;
						},
						choice: function (args, data) {
							// Get the original template
							const original = Choices.defaults.templates.choice.call(this, args, data);

							// Create new element with flag and hidden full name
							const element = strToEl(`
            <div class="country-choice-wrapper">
              <span class="fi fi-${data.customProperties.code}"></span>
              <span class="country-name">${data.label}</span>
              <span class="country-code">${data.value}</span>
            </div>
          `);

							// Replace the original content
							original.innerHTML = '';
							original.appendChild(element);

							return original;
						}
					};
				}
			});

		}

	}

})(jQuery);


export default contactFormInit;